import { z } from 'zod/v4';
import { VoucherCategory } from '../../economy/vouchers/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    isPrincipal: z.boolean().optional(),
    category: z.enum(VoucherCategory).optional(),
    since: z.iso.date().optional(),
});
const itemSchema = z.object({
    voucherId: z.uuid(),
    referenceId: z.string().nullable(),
    label: z.string(),
    category: z.enum(VoucherCategory),
    amount: z
        .string()
        .describe('Decimal amount in the case currency that counts toward the balance: what is left of the voucher after write-offs. Debt is negative, payments positive.'),
    originalAmount: z
        .string()
        .nullable()
        .describe('Decimal amount as originally entered. Null for calculated interest.'),
    writtenOffAmount: z
        .string()
        .describe('Decimal amount written off (expired or irrecoverable), as a positive number.'),
    expired: z.boolean().describe('Marked expired (time-barred).'),
    transactedAt: z.iso.datetime().nullable(),
    isPrincipal: z.boolean(),
    referenceVoucherId: z.uuid().nullable(),
});
const facetsSchema = z.object({
    byCategory: z.record(z.enum(VoucherCategory), z.number().int()),
    totalAmount: z
        .string()
        .describe('Sum of the amounts of every voucher on the case: the outstanding balance, negative while debt is owed.'),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchVouchersTool = {
    name: ToolName.SearchVouchers,
    category: ToolCategory.Vouchers,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'List vouchers on this case (principal claim, interest, fees, payments). Most recent first. Facets show counts by type and total amount. Use get_voucher for distribution and interest detail on a specific voucher. Expiry, write-offs and original amounts are internal: never mention them to the debtor, who is only told what they owe (amount).',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-vouchers.js.map